import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
};
export const VipDeskIcon = (props: Props) => {
    const { width = 40, height = 40, fill = 'currentColor', ...restProps } = props;
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 40 40" fill="none" {...restProps}>
            <path 
                d="M34.8129 36.6135V23.0059C34.8129 21.349 33.4698 20.0059 31.8129 20.0059H8.18701C6.53016 20.0059 5.18701 21.349 5.18701 23.0059V36.6135" 
                stroke={fill} 
                strokeWidth="1.2"/>
            <path 
                d="M16.439 29.0616L14.723 24.2949H15.7853L16.9429 27.652H16.9565L18.1073 24.2949H19.1764L17.4536 29.0616H16.439Z" 
                fill={fill}/>
            <path 
                d="M19.6025 29.0616V24.2949H20.6104V29.0616H19.6025Z" 
                fill={fill}/>
            <path 
                d="M21.5576 29.0616V24.2949H23.512C24.5266 24.2949 25.1667 24.8874 25.1667 25.8679C25.1667 26.8553 24.5402 27.4341 23.4983 27.4341H22.5654V29.0616H21.5576ZM22.5654 26.508H23.4847C23.8865 26.508 24.1589 26.2629 24.1589 25.8611C24.1589 25.4253 23.9273 25.2142 23.4915 25.2142H22.5654V26.508Z" 
                fill={fill}/>
            <path 
                d="M12.1746 34.8983V30.1317H13.8293C15.0959 30.1317 15.9198 31.0305 15.9198 32.515C15.9198 34.0131 15.0959 34.8983 13.8225 34.8983H12.1746ZM13.1824 33.9722H13.8225C14.4898 33.9722 14.912 33.4888 14.912 32.515C14.912 31.5481 14.4898 31.0578 13.8225 31.0578H13.1824V33.9722Z" 
                fill={fill}/>
            <path 
                d="M16.5835 34.8983V30.1317H19.6546V31.0578H17.5913V32.0247H19.4707V32.91H17.5913V33.9722H19.6614V34.8983H16.5835Z" 
                fill={fill}/>
            <path 
                d="M22.0757 35.0005C20.9385 35.0005 20.2303 34.4149 20.0601 33.3253L21.0474 33.1142C21.17 33.8224 21.456 34.0948 22.0893 34.0948C22.5592 34.0948 22.8247 33.9246 22.8247 33.625C22.8247 33.2981 22.5932 33.1211 21.8033 32.8555C20.6933 32.481 20.278 32.0792 20.278 31.3778C20.278 30.5811 20.9385 30.0295 21.8918 30.0295C22.8315 30.0295 23.5534 30.5879 23.7032 31.4323L22.7226 31.6434C22.5932 31.1599 22.3276 30.9352 21.8918 30.9352C21.5173 30.9352 21.2722 31.1054 21.2722 31.371C21.2722 31.6161 21.4764 31.7523 22.1846 31.9907C23.3695 32.3992 23.8325 32.8555 23.8325 33.625C23.8325 34.4489 23.1244 35.0005 22.0757 35.0005Z" 
                fill={fill}/>
            <path 
                d="M24.4304 34.8983V30.1317H25.4382V32.0792H25.4518L27.0521 30.1317H28.2301L26.4801 32.2426L28.3663 34.8983H27.1678L25.8604 32.9917H25.8468L25.4382 33.4888V34.8983H24.4304Z" 
                fill={fill}/>
            <path 
                d="M24.5221 18.1628V13.9727C24.5221 12.8681 23.6267 11.9727 22.5221 11.9727H17.4778C16.3732 11.9727 15.4778 12.8681 15.4778 13.9727V18.1628" 
                stroke={fill} 
                strokeWidth="1.2"/>
            <circle cx="20" cy="7.60621" r="2.4109" stroke={fill} strokeWidth="1.2"/>
        </svg>
    );
};
